type EmployeeCounts = {
  fullTimeEmployees?: number | string | null;
  partTimeEmployees?: number | string | null;
} | null | undefined;

const toDisplay = (value: number | string | null | undefined) =>
  value === null || value === undefined ? "" : String(value).trim();

/**
 * Update Member Step 3 Member Size (Monday 13252201858). A Step 5 renewal
 * details save is queued as a pending membership change for the next
 * renewal, so its full-time and part-time numbers show first. Without a
 * pending change, the current membership numbers show.
 */
export const getMemberSizeDisplayValues = ({ pendingNewMembership, current }: {
  pendingNewMembership: EmployeeCounts;
  current: EmployeeCounts;
}): { fullTimeEmployees: string; partTimeEmployees: string } => {
  const source = pendingNewMembership || current;
  return {
    fullTimeEmployees: toDisplay(source?.fullTimeEmployees),
    partTimeEmployees: toDisplay(source?.partTimeEmployees),
  };
};
